import ButtonV2 from '@components/ButtonV2/ButtonV2';
import Link from '@components/Link/Link';
import { DueDateProps } from '@components/types';
import styled from 'styled-components';
import { Amount, FlexColoumn } from '../../App.styled';

export const ContentWrapper = styled(FlexColoumn)`
    justify-content: space-between;
    flex-direction: row;
    height: 100%;
    button {
        align-self: flex-end;
    }
    button:hover {
        background: ${({ theme: { colors } }) => colors.darkGreenShade};
    }
    @media screen and (max-width: 1200px) {
        flex-direction: column;
        margin: 0;
        width: auto;
        align-items: center;
        text-align: center;
        button {
            align-self: center;
        }
    }
`;

export const DueDate = styled.div<DueDateProps>`
    color: ${({ theme: { colors }, isPastDueAcc }) => (isPastDueAcc ? 'red' : colors.cyanDarkBlue)};
    font-size: 14px;
    font-weight: bold;
    letter-spacing: 0;
    line-height: 19px;
    display: flex;
    align-items: center;
    gap: 5px;
`;

export const ThanksMsg = styled(Amount)``;

export const MinAmount = styled.div`
    align-self: flex-end;
`;

export const AmtWrapper = styled.div`
    display: flex;
    flex-direction: column;
    color: ${({ theme: { colors } }) => colors.cyanDarkBlue};
    font-size: 14px;
    font-weight: bold;
    letter-spacing: 0;
`;

export const PayWrapper = styled.div`
    display: flex;
    align-items: flex-start;
`;

export const Wrapper = styled.div`
    display: flex;
    align-items: center;
`;

export const InfoText = styled.div`
    color: ${({ color }) => color || '#656565'};
    font-size: 12px;
    font-weight: 500;
    letter-spacing: 0;
    line-height: 16px;
`;

export const InfoTextTC = styled(InfoText)`
    font-weight: normal;
    opacity: 0.7;
`;

export const VerticleLine = styled.div`
    height: 85%;
    width: 1.5px;
    margin: 0 14px;
    background-color: #979797;
`;

export const DetailsText = styled.div`
    color: ${({ color }) => color};
    font-size: 20px;
    font-weight: bold;
    letter-spacing: 0;
    line-height: 26px;
`;

export const ButtonWrapper = styled.div`
    display: flex;
    justify-content: space-between;
    flex-direction: column;
    gap: 14px;
    align-items: center;
`;

export const PayLinkWrapper = styled.div`
    display: flex;
    gap: 11px;
    flex-direction: column;
    align-items: center;
    font-size: 14px;
    font-weight: 500;
    letter-spacing: 0;
    line-height: 14px;

    @media screen and (max-width: 800px) {
        width: 129px;
        line-height: 16px;
        gap: 15px;
    }
`;

export const PayButton = styled(ButtonV2)`
    font-size: 18px;
    width: 232px;
    height: 56px;
    font-weight: 500;
`;

export const NextPayDue = styled.div`
    color: ${({ theme: { colors } }) => colors.cyanDarkBlue};
    font-size: 14px;
    font-weight: bold;
    letter-spacing: 0;
    line-height: 19px;
    margin-top: 8px;
    align-self: flex-start;
`;

export const EscrowInfo = styled.span`
    font-size: 14px;
    letter-spacing: 0;
    line-height: 19px;
`;

export const EscrowSeeMore = styled.span`
    display: inline-block;
`;

export const SeeMoreLink = styled(Link)`
    font-size: 14px;
    color: #0a4a8d;
    margin-right: 4px;
`;
